import {QbElement} from "@qb-assets-js/qb-elements/qb-element";
import {POST, PATCH, PUT, DELETE} from "../qb3-element";

// style.textContent = `[itemid="${document.documentElement.dataset.userId}"] {
//     --_slot-name-background: var(--color-highlight-bg);
//     --_slot-name-color: var(--color-highlight-fg);
// }`;

// <style title="slots" media="adoptable">
//     [itemid="<%= current_entity_id %>"] {
//     --_slot-name-background: var(--color-highlight-bg);
//     --_slot-name-color: var(--color-highlight-fg);
// }
// </style>
const styleSheet = AdoptableStyleSheet.sheet("slots");
document.adoptStyleSheets("slots");

const missing = new Map();



function avatar_pathname(itemid) {
    const url = new URL(location);
    const uuidRE = new RegExp(`(/${UUID_RE.source})(?:.*)?$`);
    if(uuidRE.test(url.pathname)) url.pathname = url.pathname.replace(uuidRE, `$1/avatars`);
    else url.pathname = "/avatars";
    if(itemid) url.pathname += `/${itemid}`;
    return url.pathname;
}

function loadRule() {
    if(!missing.size) return;
    const avatars = [...missing];
    missing.clear();
    POST(avatar_pathname(), {body: {avatars}}).result({
        json: ({avatars}) => {
            for(const {itemid, itemtype, ...data} of avatars) {
                const entity = document.body.querySelector(`[itemid="${itemid}"]`);
                if(!entity) {
                    console.warn("Entity not found", {itemid, itemtype, ...data});
                    continue;
                }
                entity.update(data);
            }
        }
    });
}

self.participantsIndex = {}

let load_ta;
function addMissing(itemid, itemtype) {
    const type = missing.get(itemid);
    if(!type) missing.set(itemid, itemtype);
    else if(type === "User" && itemtype === "Player")  missing.set(itemid, itemtype);
    else return;
    clearTimeout(load_ta);
    load_ta = setTimeout(loadRule, 50)
}

function getRule(itemid, node) {
    if(!itemid) return console.warn("getRule", node, "No itemid");
    const regexp = new RegExp(`="${itemid}"\\]`);
    const cssRules = [...styleSheet.cssRules];
    const rule = cssRules.find(rule => regexp.test(rule?.selectorText));
    const rv = {}
    if(rule) for(const prop of rule.style) {
        const key = prop.replace(/^--slot-/, "").replace("-", "_");
        let val = rule.style.getPropertyValue(prop);
        if(!val) continue;
        switch(key) {
            case "index":
                rv.index_num = parseInt(val);
            case "name":
            case "avatar":
                val = val.replace(/^"|"$/g, "");
                break;
            case "index_num":
                val = parseInt(val);
                break;
            case "color":
                break;
            default:
                continue;
        }
        rv[key] = val;
    }
    else if(node) {
        addMissing(itemid, node.itemtype);
    }
    return rv;
}

function deleteRule(itemid) {
    const regexp = new RegExp(`="${itemid}"\\]`);
    const rules = [...styleSheet.cssRules],
        indices = [];
    rules.forEach((rule, i) => regexp.test(rule?.selectorText) && indices.push(i));
    indices.reverse().forEach(index => styleSheet.deleteRule(index));
}

function addRule(itemid, rule) {
    const ruleText = [];
    Object.entries(rule).forEach(([k, v]) => {
        if(!v && v !== 0) return;
        switch(k) {
            case "name":
            case "avatar":
                ruleText.push(`--slot-${k.replace("_", "-")}:"${v}"`);
                break;
            case "color":
                const r = parseInt(v.substring(1,3),16),
                    g = parseInt(v.substring(3,5),16),
                    b = parseInt(v.substring(5,7),16),
                    lum = (0.299*r + 0.587*g + 0.114*b)/255;
                ruleText.push(lum > 0.5 ? '--slot-color-fg:#000' : '--slot-color-fg:#fff');
                ruleText.push(`--slot-color:${v}`);
                break;
            case "index":
            case "index_num":
                ruleText.push(`--slot-index:"${v}"`);
                ruleText.push(`--slot-index-num:${v}`);
        }
    });
    deleteRule(itemid);
    const cssText = `[itemid$="${itemid}"], [id$="${itemid}"] { ${ruleText.join(";")}; }`;
    styleSheet.insertRule(cssText, styleSheet.cssRules.length);
    missing.delete(itemid);
    if(!missing.size) clearTimeout(load_ta);
}

export class QbParticipantBase extends QbElement {
    static shadow = {mode: 'open', sheets: ["qb-elements"]};
    static observedAttributes = ["itemid", "data-index"];
    static template = '<div part="avatar" class="avatar"></div><div part="name" class="name"></div><slot part="slot"></slot>';
    #isParticipant

    get init() {
        super.init;
        this.addClass("qb-entity");
        if(this.name) {

        }
        else {
            if(!this.itemid) return;
            const css = this.getRule;

        }

        if(this.parentNode?.nodeName === "QB-PARTICIPANTS") {
            this.#isParticipant = true;
            self.participantsIndex[this.itemid] = this;
        }
    }

    disconnected() {
        if(this.#isParticipant) delete self.participantsIndex[this.itemid];
    }

    #property(name) { return getComputedStyle(this).getPropertyValue(`--slot-${name}`) }

    get name() { return this.#property('name')?.replace(/^"|"$/g, "")?.replace(/\\"/g, '"') };

    set name(name) { this.update({name}) }

    get color() { return this.#property('color') }

    set color(color) { this.update({color}) }

    get avatar() { return this.#property('avatar')?.replace(/^"|"$/g, "") }

    set avatar(avatar) { this.update({avatar}) }

    set slot_index(index) {
        this.dataset.index = index;
        this.update({index})
    }

    set index(index) {
        this.dataset.index = index;
        this.update({index})
    }


    set seen_at(value) {
        this.dataset.seen_at = value;
    }

    get getRule() {
        const rv = {};
        let val = false;
        const style = getComputedStyle(this);
        for(const prop of style) {
            if(!prop.startsWith("--slot")) continue;
            const key = prop.replace(/^--slot-/, "").replace("-", "_");
            val = style.getPropertyValue(prop);
            switch(key) {
                case "index":
                    rv.index_num = parseInt(val);
                case "name":
                case "avatar":
                    val = val.replace(/^"|"$/g, "");
                    break;
                case "index_num":
                    val = parseInt(val);
                    break;
                case "color":
                    break;
                default:
                    continue;
            }
            rv[key] = val;
        }
        if(val === false) {
            addMissing(this.itemid, this.itemtype);
        }
        return rv;
    }

    get index() {
        const index = getRule.index;
        // if(!this.dataset.index && index) this.dataset.index = index;
        return parseInt(index);
    }

    set itemid(itemid) {
        this.update({itemid})
    }

    $itemid(itemid, old) {
        if(old) return;
        const css = this.getRule;
        // document.body.querySelectorAll(`${this.nodeName}[itemid="${this.itemid}"]`).forEach(n=>{
        //     n.ariaLabel = css.name;
        //     if(css.index) n.dataset.index = css.index;
        // });
    }

    get itemid() { return this.getAttribute("itemid") }

    get itemtype() {
        const str = this.nodeName.slice(3);
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    set itemtype(_) {}

    save(value) {
        // debugger;
        this.update(value);
        // const avatar = getRule(this.itemid);
        const avatar = value;
        PATCH(avatar_pathname(this.itemid), {body: {avatar, itemtype: this.itemtype}});
    }

    get sync_aria() {
        if(!this.name) return;
        let description = this.nodeName.slice(3);
        if(description === "SLOT") description = "Team";
        const ariaLabel = `${description} ${this.name}`;
        document.body.querySelectorAll(`.qb-entity[itemid="${this.itemid}"]`).forEach(n=>{
            n.ariaLabel=ariaLabel;
            // if(this.index) n.dataset.index = this.index;
        });
    }

    update(value) {
        const {name, color, avatar, index, itemtype, itemid, data, ...other} = value;
        if(!this.itemtype) this.setAttribute("itemtype", itemtype);
        if(!this.itemid && itemid) this.setAttribute("itemid", itemid);
        const css = getRule(this.itemid);
        let changed = false;
        if(('name' in value && css.name !== name)) {
            changed = true;
            document.querySelectorAll(`[itemid="${this.itemid}"] [itemprop="name"]`).forEach(n=>n.textContent = name);
            css.name = name;
        }
        if(('color' in value) && css.color !== color) {
            changed = true;
            css.color = color;
        }
        if(this.nodeName !== "QB-SLOT" && ('avatar' in value) && css.avatar !== avatar) {
            changed = true;
            css.avatar = avatar;
        }
        if(('index' in value) && !isNaN(parseInt(index)) && css.index !== index) {
            // if(css.index === undefined) debugger;
            changed = true;
            css.index = css.index_num = index;
            if(this.nodeName === "QB-SLOT") {
                this.dataset.index = css.avatar = index;
            }
            else if(this.nodeName === "QB-PLAYER") {
                const current = this.index;
                if(current !== index && this.parentNode?.nodeName === "QB-PARTICIPANTS") {
                    const slot = document.body.querySelector(`qb-participants qb-slot[data-index="${index}"]`);
                    slot?.after(this);
                    if(self.isPlayer && this.itemid === self.user_id) {
                        this.addClass("me");
                        slot?.addClass("me");
                        const joined = slot?.querySelector('input[name="slot"][type="radio"]');
                        if(joined) joined.checked = true;
                    }
                }
                this.dataset.index = index;
            }
        }
        if(changed) {
            addRule(this.itemid, css);
            this.sync_aria;
        }
        super.update(other);
        if('data' in value) this.update(data);
        return this;
    }



    set member_only(_) {}

    get member_only() {}

    #staff
    get staff() { return this.hasClass("admin") }

    set staff(value) {
        this.#staff = !!value;
        this.setClass(value, "admin");
    }



    set chat(value) { this.setClass(value, "chat") }

    get chat() { this.hasClass("chat") }



    set current_index(_) {}

    get current_index() { }

    set seconds(value) {
        if(value) this.dataset.seconds = value;
        else delete this.dataset.seconds;
    }

    get seconds() { return this.dataset.seconds }

    get show() {
        return self.Show || this.closest("qb-show");
    }

    set team_id(_) {}

    handleEvent_slot_select(evt) {
        const node = evt.currentTarget, parent = this.parentNode;
        PUT(`/show/${self.show_id}/${node.value}`).result({
            json: participants => {
                if(!(participants instanceof Array)) return;
                for(const rv of participants) {
                    console.log("json", rv); // todo switch in background
                    if(rv?.remove) {
                        self.slot_id = null;
                        self.slot_index = 0;
                        parent.querySelectorAll(`.qb-entity[itemid="${rv.itemid}"]`).forEach(n => n.remove());
                    }
                    else if(rv?.itemtype === "Slot") {
                        const {room_service_url, room_service_token, itemid, ...data} = rv;
                        self.slot_id = itemid;
                        self.slot_index = data.index;

                        const meta = document.head.querySelector('meta[name="RoomService"]');
                        meta.setAttribute("token", room_service_token);
                        meta.content = room_service_url;
                        self.RoomService.reload;
                        if(data.index !== 0) {
                            parent.querySelectorAll(`qb-slot[itemid="${itemid}"],qb-slot[data-index="${data.index}"]`).forEach(n => n.remove());
                            cT("qb-slot", {itemid, beforeend: parent}).update(data).slot_selected = true;
                        }
                        else {
                            parent.querySelector(`qb-slot[itemid="${itemid}"]`).slot_selected = true;
                        }
                    }
                    else if(rv?.itemtype === "Player") {

                    }
                }
                // location = `/show/${self.show_id}/${data.index}`;
            }
        });
        if(node.nodeName === "SELECT") node.value = "";
    }
}


export class QbParticipantPerson extends QbParticipantBase {
    get init() {
        super.init;
        this.addClass("qb-entity-person");
    }

    set staff(value) {
        super.staff = value;
    }

    get staff() { return this.hasClass("admin") }
}

export class QbParticipantCollection extends QbParticipantBase {
    get init() {
        super.init;
        this.addClass("qb-entity-collection");
    }

    set slot_selected(value) {
        if(value === null) return this.querySelector('input[name^="slot-"]')?.remove();
        this.slot_select.checked = value;
    }

    get slot_selected() {
        return this.querySelector('input[name^="slot-"]')?.checked;
    }

    get slot_select() {
        const name = `slot-${user_id}`,
            id = `${name}-${this.itemid}`;
        if(!this.children[id]) this.append(
            LABEL({htmlFor: id, itemprop: "name"}, this.name),
            INPUT({type: "radio", name, id, value: `/player/${user_id}/slot/${this.itemid}`,
                checked: this.isMySlot, events: [this, {change: "slot_select"}],
                ariaLabel: `Play with this team`
            })
        );
        return this.children[id];
    }

    handleEvent_edit(evt) {
        const content = FORM({ events: [this, "submit"]}, LABEL(_("Team name"), BR(), INPUT({type: "text", name: "name", value: this.name})), BUTTON({class: "button"},_("Change")));
        return new DialogCtrl("team_edit", {class: "modal"}, content, data=>{
            console.log(data)
        }).open;
    }

    handleEvent_submit(evt) {
        evt.preventDefault();
        const formData = new FormData(evt.target);
        const body = Object.fromEntries(formData.entries());
        PATCH("teams", this.itemid, {body: body}).result({
                200: () => { evt.target.closest("dialog").close() }
        });
    }

    set join_token(value) {
        if(this.index === 0 || this.dataset.index === "0") return;
        let node = this.querySelector(".join-code");
        if(!value) return node?.remove();
        if(!node) {
            const title = _(`Click to copy this code and share for your friends to join your team.`);
            node = A({
                href: `${location}?code=${value}`,
                role: "button",
                title, ariaLabel: title,
                class: "join-code",
                onclick: e => { self.copyText(e.currentTarget.href); return false },
                beforeend: this
            }, value);
        }
        node.textContent = value;
    }

    set slot_join_token(value) {
        console.warn("slot_join_token", value);
        this.join_token = value;
    }




//
//     const itemid = self.user_id,
//     name = `slot-${self.user_id}`,
//     id = `${name}-${this.itemid}`;
//     this.append(
//         LABEL({htmlFor: id},
// SPAN({class: "ask_to_join"}, _("Ask to join team")),
//     SPAN({class: "join_restricted"}, _("🚫 Ask to join team just if you know them.")),
//     SPAN({class: "join_requested"}, _("Permission requested."))
// ),
// INPUT({type: "radio", name, id, value: `/player/${itemid}/slot/${this.itemid}`, events: [this, {change: "team"}]})
// );


// LABEL({beforeend: this, class: "join_team"},
//     cT.RadioButton(`slot`, this.dataset.slot_index, false, {
//         autocomplete: "off",
//         ariaLabel: _("Ask to join team"),
//         events: [this, {change: "join"}]
//     }),
//
// )

}
